import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/auth'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        auth: {
            sessionToken: null,
            role: null,
            expires: null,
        },
    },
    mutations: {
        setAuth(state, data) {
            state.auth = data
        },

        clearAuth(state) {
            state.auth.sessionToken = null
            state.auth.role = null
            state.auth.expires = null
        },
    },
    actions: {},
    modules: {
        Auth,
    },
    plugins: [createPersistedState({ storage: window.sessionStorage })],
})

export const roles = {
    admin: 10,
    user: 20,
}
